module.exports = __webpack_public_path__ + "img/Estonia.15c2a235.gif";